module.exports = __webpack_public_path__ + "static/img/show2.34a97112.png";